// src/components/study/ReportErrorModal.tsx
// =====================================================================
// MODAL DE REPORT DE ERROS - IDENTIDADE GRAIA
// Minimalista, funcional, sem emojis
// =====================================================================

import React, { useState } from 'react';
import { X, AlertTriangle } from 'lucide-react';
import './ReportErrorModal.css';

interface ReportErrorModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (errorType: string, errorDetails: string) => Promise<void>;
}

const ReportErrorModal: React.FC<ReportErrorModalProps> = ({
    isOpen,
    onClose,
    onSubmit
}) => {
    const [errorType, setErrorType] = useState('');
    const [errorDetails, setErrorDetails] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
        if (!errorType) {
            alert('Selecione o tipo de erro');
            return;
        }

        setIsSubmitting(true);
        try {
            await onSubmit(errorType, errorDetails);
            // Resetar após sucesso
            setErrorType('');
            setErrorDetails('');
            onClose();
        } catch (error) {
            console.error('Erro ao reportar:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        setErrorType('');
        setErrorDetails('');
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="report-modal-overlay" onClick={handleClose}>
            <div className="report-modal-container" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="report-modal-header">
                    <div className="report-modal-title-wrapper">
                        <AlertTriangle size={20} className="report-modal-icon" />
                        <h3 className="report-modal-title">Reportar erro</h3>
                    </div>
                    <button
                        className="report-modal-close"
                        onClick={handleClose}
                        aria-label="Fechar"
                        disabled={isSubmitting}
                    >
                        <X size={18} />
                    </button>
                </div>

                {/* Hint */}
                <p className="report-modal-hint">
                    Encontrou um problema neste card? Ajude-nos a melhorar.
                </p>

                {/* Form */}
                <div className="report-modal-form">
                    <div className="report-form-group">
                        <label className="report-form-label">Tipo de erro *</label>
                        <select
                            value={errorType}
                            onChange={(e) => setErrorType(e.target.value)}
                            className="report-form-select"
                            disabled={isSubmitting}
                        >
                            <option value="">Selecione o tipo</option>
                            <option value="Erro de conteúdo">Erro de conteúdo</option>
                            <option value="Erro ortográfico">Erro ortográfico</option>
                            <option value="Formatação">Formatação</option>
                            <option value="Outro">Outro</option>
                        </select>
                    </div>

                    <div className="report-form-group">
                        <label className="report-form-label">Detalhes (opcional)</label>
                        <textarea
                            placeholder="Descreva o problema encontrado..."
                            value={errorDetails}
                            onChange={(e) => setErrorDetails(e.target.value)}
                            className="report-form-textarea"
                            rows={4}
                            disabled={isSubmitting}
                        />
                    </div>
                </div>

                {/* Actions */}
                <div className="report-modal-actions">
                    <button
                        className="report-btn-cancel"
                        onClick={handleClose}
                        disabled={isSubmitting}
                    >
                        Cancelar
                    </button>
                    <button
                        className="report-btn-submit"
                        onClick={handleSubmit}
                        disabled={!errorType || isSubmitting}
                    >
                        {isSubmitting ? 'Enviando...' : 'Enviar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReportErrorModal;